import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";

export class ProvisionalCrown extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram, true)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    const resolvedConditions = [
      "wear",
      "caries",
      "restoration",
      "veneer",
      "crown",
      "onlay",
      "denture",
      "bridge",
      "adhesive-bridge",
      "severely-damaged",
    ];

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis = tooth.diagnosis
          .filter(
            (diagnosis) => !resolvedConditions.includes(diagnosis.condition),
          )
          .filter(
            (diagnosis) =>
              !(
                diagnosis.condition === "fracture" &&
                diagnosis.options.includes("crown")
              ),
          );
        tooth.plan.push({ treatment: item.treatment });
      });

    return odontogram;
  }

  static getIdentifier(): string {
    return "provisional-crown";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/prostho/provisional-crown.ts